import React from "react";
import Menu from "@mui/material/Menu";
import MenuContent from "./MenuContent";

interface MenuProps {
    anchorEl: null | HTMLElement;
    id: string;
    isMenuOpen: boolean;
    handleMenuClose: () => void;
    setOpen: any;
    isMobile?: boolean;
}

const HeaderNavMenu: React.FC<MenuProps> = ({
    anchorEl,
    id,
    isMenuOpen,
    handleMenuClose,
    setOpen,
    isMobile,
}) => {
    return (
        <Menu
            anchorEl={anchorEl}
            id={id}
            open={isMenuOpen}
            onClose={handleMenuClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    width: "12rem",
                    overflow: "visible",
                    // filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
            {isMobile ? (
                <MenuContent
                    handleMenuClose={handleMenuClose}
                    setOpen={setOpen}
                />
            ) : (
                <MenuContent
                    handleMenuClose={handleMenuClose}
                    setOpen={setOpen}
                />
            )}
        </Menu>
    );
};

export default HeaderNavMenu;
